import React, { useState } from 'react';
import Controller from './Controller';

import { NewDialog } from 'components';
import { Badge, Button } from '@mui/material';
import { digitsEnToFa } from '@persian-tools/persian-tools';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';

export default function Control({ id, count, refetch }) {
  const [open, setOpen] = useState(false);
  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  return <Controller id={id} refetch={refetch} onClose={onClose} />;

  return (
    <>
      <Badge
        color="primary"
        overlap="circular"
        invisible={!count}
        badgeContent={digitsEnToFa(count || '')}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Button
          size="small"
          color="primary"
          variant="outlined"
          onClick={onOpen}
          endIcon={<AssignmentRoundedIcon color="inherit" fontSize="small" />}
        >
          جزییات
        </Button>
      </Badge>
      <NewDialog label="assign" open={open} onClose={onClose}>
        {/* <NewDialogTitle title="محصولات" onClose={onClose} /> */}
        {/* <NewDialogContent isPopup> */}
        {/* <Stack p={1} flex={2} rowGap={1} bgcolor="background.paper"> */}
        <Controller id={id} refetch={refetch} onClose={onClose} />
        {/* </Stack> */}
        {/* </NewDialogContent> */}
        {/* <NewDialogActions>
          {formData && (
            <Stack direction="row" width="100%" columnGap={1}>
              <AssignSelectedProduct
                coupon={coupon}
                refetch={refetch}
                shop={formData?.shop?.id}
                products={formData?.products_shop}
                active={type === 'SELECTED_PRODUCT'}
              />
              <AssignCategory coupon={coupon} refetch={refetch} active={type === 'CATEGORY'} />
              <AssignAllProduct coupon={coupon} refetch={refetch} active={type === 'ALL_PRODUCT'} />
            </Stack>
          )}
        </NewDialogActions> */}
      </NewDialog>
    </>
  );
}
